<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <SalaryReportByBank
              v-if="st == 20"
              :report-list="
                privateCompanyMode ? CurrentReportList : CurrentReportList_true
              "
              @changeReport="st = $event"
            />
            <OverTimeReport
              v-else-if="st == '21'"
              :report-list="
                privateCompanyMode ? CurrentReportList : CurrentReportList_true
              "
              :employees="employees"
              @changeReport="st = $event"
            />
            <md-card-content v-else>
              <div class="md-layout">
                <div
                  v-if="privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 ml-15"
                >
                  <label>نوع التقرير</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="CurrentReportList"
                    v-model="st"
                    option-value="id"
                    option-text="name"
                  ></model-list-select>
                </div>

                <div
                  v-else
                  class="md-layout-item md-size-30 md-small-size-100 ml-15"
                >
                  <label>نوع التقرير</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="CurrentReportList_true"
                    v-model="st"
                    option-value="id"
                    option-text="name"
                  ></model-list-select>
                </div>

                <div
                  v-if="st == '16' || st == '17' || st == '19'"
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>الموظف</label>
                  <model-list-select
                    multiple
                    class="input-must-rtl"
                    :list="employees"
                    v-model="EmployeeId_Report"
                    option-value="key"
                    option-text="value"
                  >
                  </model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('EmployeeId_Report')"
                  />
                </div>

                <div
                  v-if="st == '17' || st == '18'"
                  class="md-layout-item md-layout-item-time md-size-30 ml-15"
                  style="position: relative"
                >
                  <h4 class="monthly-picker-head" :class="{ active: date }">
                    التاريخ
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="date"
                  />
                </div>

                <div
                  v-if="st == '17'"
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="detailedReport">
                    تقرير تفصيلي
                  </md-checkbox>
                </div>

                <div
                  v-if="st == '16'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>السنة</label>
                    <md-input type="number" v-model="Year_Report"></md-input>
                  </md-field>
                </div>

                <!-- <v-select multiple v-model="selected" :options="['Canada','United States']" /> -->

                <div
                  v-if="
                    st == '2' ||
                    st == '4' ||
                    st == '5' ||
                    st == '11' ||
                    st == '13' ||
                    st == '14'
                  "
                  class="md-layout-item md-layout-item-time md-size-30 ml-15 mt-25"
                  style="position: relative"
                >
                  <h4
                    class="monthly-picker-head"
                    :class="{ active: monthDate }"
                  >
                    شهر المرتب
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="monthDate"
                  />
                </div>

                <div
                  v-if="st == '5' || st == '14'"
                  class="md-layout-item md-size-30 ml-15 mt-25"
                >
                  <md-field>
                    <label>اختر البنك</label>

                    <md-select v-model="selectBank">
                      <md-option
                        v-for="(item, i) in allBanks"
                        :key="i"
                        :value="item.key"
                        >{{ item.value }}</md-option
                      >
                    </md-select>

                    <button
                      @click="clear_selectBank"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                  </md-field>
                </div>

                <div
                  v-if="st == '5' || st == '14'"
                  class="md-layout-item md-size-30 ml-15 mt-25"
                >
                  <md-field>
                    <label>اختر فرع للبنك</label>

                    <md-select v-model="selectBankBranch">
                      <md-option
                        v-for="(item, i) in allBankBranches"
                        :key="i"
                        :value="item.key"
                      >
                        {{ item.value }}
                      </md-option>
                    </md-select>

                    <button
                      @click="clear_selectBankBranch"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                  </md-field>
                </div>

                <div
                  v-if="st == '7' || st == '8' || st == '9'"
                  class="md-layout-item md-layout-item-time md-size-30 mt-25 ml-15"
                  style="position: relative"
                >
                  <h4 class="monthly-picker-head" :class="{ active: StartOn }">
                    من تاريخ الشهر
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="StartOn"
                  />
                </div>

                <div
                  v-if="st == '7' || st == '8' || st == '9'"
                  class="md-layout-item md-layout-item-time md-size-30 mt-25 ml-15"
                  style="position: relative"
                >
                  <h4 class="monthly-picker-head" :class="{ active: FinishOn }">
                    الى تاريخ الشهر
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="FinishOn"
                  />
                </div>

                <div
                  v-if="
                    st == '5' ||
                    st == '14' ||
                    st == '13' ||
                    st == '18' ||
                    st == '2' ||
                    st == '4' ||
                    st == '7' ||
                    st == '8' ||
                    st == '9' ||
                    st == '11'
                  "
                  class="md-layout-item md-size-30 ml-15 mtb-25"
                >
                  <md-field>
                    <model-list-select
                      class="input-must-rtl"
                      :list="bankClassifications"
                      v-model="bankClassificationId"
                      option-value="key"
                      option-text="value"
                      placeholder="تصنيف فرع المصرف"
                    ></model-list-select>
                    <button
                      @click="clear_bankClassificationId"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 mt-25 ml-15"
                  v-if="st == '18'"
                >
                  <md-checkbox v-model="includeJobInfo" class="md-primary">
                    <!-- style="margin-top: 35px" -->
                    تضمين البيانات الوظيفية
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-60 mt-25 ml-15"
                  style="min-width: 62% !important"
                  v-if="st == '18'"
                >
                  <md-field>
                    <label>الموظف</label>
                    <v-select
                      style="width: 100%"
                      dir="rtl"
                      multiple
                      :reduce="(item) => item"
                      label="value"
                      v-model="EmployeesId"
                      :options="employees"
                      placeholder="الموظف"
                    ></v-select>
                  </md-field>
                </div>

                <div
                  style="
                    padding-left: 30px !important;
                    min-width: 95% !important;
                  "
                  v-if="
                    st == '5' ||
                    st == '14' ||
                    st == '13' ||
                    st == '18' ||
                    st == '2' ||
                    st == '4' ||
                    st == '7' ||
                    st == '8' ||
                    st == '9' ||
                    st == '11'
                  "
                  class="md-layout-item md-size-90 mt-25"
                >
                  <md-field>
                    <label>التصنيفات</label>

                    <md-select
                      multiple
                      v-model="FilterDeparmentClassificationsIds"
                    >
                      <md-option
                        v-for="(item, i) in deparmentClassifications"
                        :key="i"
                        :value="item.key"
                        >{{ item.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25"
                  style="text-align: center"
                >
                  <md-button @click="Search" class="md-success btn_nanosoft"
                    >بحث</md-button
                  >

                  <md-button
                    v-if="
                      st == 7 ||
                      st == 8 ||
                      st == 9 ||
                      st == 2 ||
                      st == 4 ||
                      st == 11 ||
                      st == 13 ||
                      st == 18 ||
                      st == 14
                    "
                    class="md-info btn_nanosoft"
                    @click="printReportFromApi(st)"
                  >
                    طباعة PDF
                  </md-button>

                  <md-button
                    v-else
                    class="md-info btn_nanosoft"
                    @click="generateReport"
                  >
                    طباعة PDF
                  </md-button>

                  <md-button
                    v-if="st == 5 || st == 14"
                    v-show="exc"
                    @click="generateReport_ex"
                    class="md-info btn_nanosoft"
                  >
                    طباعة Excel
                  </md-button>

                  <md-button
                    v-if="st == 18"
                    class="md-info btn_nanosoft"
                    @click="SalaryInfosFile(2)"
                  >
                    طباعة Excel
                  </md-button>

                  <Excel2
                    v-if="st == 2"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :month="convert(monthDate)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel4
                    v-if="st == 4"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :month="convert(monthDate)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel5
                    v-if="false"
                    :month="convert(monthDate)"
                    :bankBranch="selectBankBranch"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel7
                    v-if="st == 7"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :from="convert(StartOn)"
                    :to="convert(FinishOn)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel8
                    v-if="st == 8"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :from="convert(StartOn)"
                    :to="convert(FinishOn)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel9
                    v-if="st == 9"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :from="convert(StartOn)"
                    :to="convert(FinishOn)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel11
                    v-if="st == 11"
                    :bankClassificationId="bankClassificationId"
                    :FilterDeparmentClassificationsIds="
                      FilterDeparmentClassificationsIds
                    "
                    :month="convert(monthDate)"
                    :date="convert(date)"
                    :name="companyName"
                    :desc="companyDesc"
                  />

                  <Excel13 v-if="false" :month="convert(monthDate)" />

                  <!-- <Excel14 :bankClassificationId="bankClassificationId"
                                        :FilterDeparmentClassificationsIds="FilterDeparmentClassificationsIds"
                                        v-if="st == 14" :month="convert(monthDate)" :bankBranch="selectBankBranch"
                                        :date="convert(date)" :name="companyName" :desc="companyDesc" /> -->

                  <Lodding v-if="lodding_bool" color="green" scale="0.4" />
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div v-if="st != 20" class="md-layout-item">
      <div class="md-layout-item md-size-20">
        <div v-if="pdfLoadingActive" class="overlay-pdf">
          <h3 class="head-loading-pdf">جارى تحميل الملف</h3>
          <atom-spinner
            class="pdfLoading"
            :animation-duration="1000"
            :size="160"
            color="#4caf50"
          />
          <div style="width: 50%">
            <step-progress
              :steps="mySteps"
              :current-step="currentStep"
              :line-thickness="50"
              :active-color="'#4caf50'"
              :passive-color="'#999999'"
            ></step-progress>
          </div>
        </div>
      </div>
      <md-card>
        <!-- ------------- show ------------- -->

        <!-- كشف تجميعي للحوافظ -->
        <div v-if="st == 2">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-30">
              <h4 class="text-left" style="margin-left: 50px">
                التاريخ : {{ convert(date) }}
              </h4>
            </div>

            <div class="md-layout-item md-size-30 mt-25">
              <h3 class="text-center">كشف تجميعي للحوافظ</h3>
              <h4 class="text-center">{{ convert_Month(monthDate) }} عن شهر</h4>
            </div>

            <div style="text-align: end" class="md-layout-item md-size-30">
              <h3 class="text-right">{{ name.fullName }}</h3>
              <h4 class="text-right">{{ name.shortName }}</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">كشف تجميعي للحوافظ</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label>عدد الموظفين</label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalCount)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label>مجموع الحوافظ</label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalValue)"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="report paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell class="reportFont" md-label="ر.م">{{
                        item.id
                      }}</md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="اسم المصرف"
                        >{{ item.bankBranchName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="العدد"
                        >{{ item.count }}
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="القيمة
                                            (د.ل)"
                        >{{ formatValues(item.value) }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="رقم الصك"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>

        <div v-if="st == 4">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-30"></div>

            <div class="md-layout-item md-size-30 mt-25">
              <h3 class="text-center">كشف مرتبات عن شهر</h3>
              <h4 class="text-center">
                {{ convert_Month(monthDate) }}
              </h4>
            </div>

            <div style="text-align: end" class="md-layout-item md-size-30">
              <h3 class="text-right">{{ name.fullName }}</h3>
              <h4 class="text-right">{{ name.shortName }}</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">كشف مرتبات عن شهر - دينار ليبي</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي المرتب </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalSalaries)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي الإستقطاعات </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalDiscountsValue)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي صافي المرتب </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalNetSalary)"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="
                      staffReportData.filter((item) => item.currency == 1)
                    "
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row
                      slot="md-table-row"
                      slot-scope="{ item, index }"
                    >
                      <md-table-cell class="reportFont" md-label="ر.م">{{
                        index + 1
                      }}</md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 140px"
                        md-label="رقم المالي"
                        >{{ item.financialNumber }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 300px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإجمالي
                                                "
                        >{{ formatValues(item.totalSalary) }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإستقطاعات
                                                "
                        >{{ formatValues(item.totalDiscounts) }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="صافي المرتب
                                                "
                        >{{ formatValues(item.netSalary) }}</md-table-cell
                      >

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <div class="md-layout" v-if="isMultiCurrency">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">كشف مرتبات عن شهر - دولار</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي المرتب </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalSalaries)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي الإستقطاعات </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalDiscountsValue)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي صافي المرتب </label>
                      <md-input
                        style="font-size: 16px !important"
                        disabled
                        :value="formatValues(tableData.totalNetSalary)"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="
                      staffReportData.filter((item) => item.currency === 2)
                    "
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row
                      slot="md-table-row"
                      slot-scope="{ item, index }"
                    >
                      <md-table-cell class="reportFont" md-label="ر.م">{{
                        index + 1
                      }}</md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 140px"
                        md-label="رقم المالي"
                        >{{ item.financialNumber }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 300px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإجمالي
                                                "
                        >{{ formatValues(item.totalSalary) }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإستقطاعات
                                                "
                        >{{ formatValues(item.totalDiscounts) }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="صافي المرتب
                                                "
                        >{{ formatValues(item.netSalary) }}</md-table-cell
                      >

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>

        <!--  تقرير الجهاد  -->

        <div v-if="st == 7">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-30">
              <h4 class="text-left" style="margin-left: 50px">
                التاريخ : {{ convert(date) }}
              </h4>
            </div>

            <div class="md-layout-item md-size-30 mt-25">
              <h3 class="text-center">تقرير الجهاد</h3>
              <div class="text-center" style="direction: ltr; display: flex">
                <h4 style="padding-right: 30px" class="text-center">
                  {{ convert_Month(FinishOn) }} الى شهر
                </h4>

                <h4 class="text-center">{{ convert_Month(StartOn) }} من شهر</h4>
              </div>
            </div>

            <div style="text-align: end" class="md-layout-item md-size-30">
              <h3 class="text-right">{{ name.fullName }}</h3>
              <h4 class="text-right">{{ name.shortName }}</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">تقرير الجهاد</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي الخاضع للضريبة </label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalSalaries)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي قيمة الجهاد </label>
                      <md-input
                        type="number"
                        disabled
                        :value="formatValues(tableData.totalJihadTax)"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        style="width: 60px"
                        class="reportFont"
                        md-label="ر.م"
                        >{{ item.id }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 150px"
                        md-label="الرقم المالي"
                        >{{ item.financialNumber }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="الإسم"
                        >{{ item.employeeName }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 200px"
                        class="reportFont"
                        md-label="الخاضع للضريبة
                (د.ل)"
                        >{{ formatValues(item.totalSalary) }}</md-table-cell
                      >

                      <md-table-cell
                        style="width: 200px"
                        class="reportFont"
                        md-label="قيمة الجهاد
                (د.ل)"
                        >{{ formatValues(item.jihadTax) }}
                      </md-table-cell>

                      <md-table-cell style="width: 5px"></md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <div class="md-layout mt-25 text-center">
            <div class="md-layout-item md-size-30">
              <p style="font-weight: bold">رئيس قسم الحسابات</p>
            </div>

            <div class="md-layout-item md-size-30">
              <p style="font-weight: bold">المراجعة الداخلية</p>
            </div>

            <div class="md-layout-item md-size-30">
              <p style="font-weight: bold">المراقب المالي</p>
            </div>
          </div>
        </div>

        <!-- كشف حصر الإشتراكات الضمانية -->

        <div v-if="st == 9">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-100">
              <h4 class="text-center">
                <span style="font-weight: bold">{{ name.fullName }}</span>
              </h4>
              <h4 class="text-center">{{ name.shortName }}</h4>
            </div>

            <div class="md-layout-item md-size-100 mt-25">
              <h3 class="text-center">كشف حصر الاشتراكات الضمانية</h3>
              <h4 class="text-center">
                المستحقة لصالح الضمان الإجتماعي لدى وزارة المالية للمضمونين لغرض
                المطابقة مع ماتم سداده للخصم المباشر
              </h4>
              <div class="text-center" style="direction: ltr; display: flex">
                <h4 class="text-center">
                  {{ convert_Month(FinishOn) }} الى شهر
                </h4>

                <h4 style="padding-left: 15px" class="text-center">
                  {{ convert_Month(StartOn) }} من شهر
                </h4>
              </div>
            </div>

            <div class="md-layout-item md-size-100">
              <h4 class="text-left" style="margin-left: 50px">
                التاريخ : {{ convert(date) }}
              </h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">كشف حصر الإشتراكات الضمانية</h4>
                  </div>
                </md-card-header>

                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي الراتب الخاضع للضمان </label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalSalries)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي حصة المضمون </label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalWarrantyTax)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> اجمالي حصة جهة العمل </label>
                      <md-input
                        disabled
                        :value="formatValues(tableData.totalEmployerTax)"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    style="margin-top: 30px"
                    class="md-layout-item md-size-30 ml-15"
                  >
                    <md-field>
                      <label> حصة الخزانة </label>
                      <md-input
                        disabled
                        v-model="tableData.totalCabinetTax"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        style="width: 60px"
                        class="reportFont"
                        md-label="ر.م"
                        >{{ item.id }}</md-table-cell
                      >

                      <md-table-cell
                        class="w-200 reportFont"
                        style="width: 400px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الرتب الخاضع للضمان"
                        >{{ formatValues(item.totalSalry) }}</md-table-cell
                      >

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة المضمون 5.125%"
                      >
                        {{ formatValues(item.warrantyTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة جهة العمل  10.500%"
                      >
                        {{ formatValues(item.employerTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة الخزانة  0.750%"
                      >
                        {{ formatValues(item.cabinetTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 100px"
                        class="reportFont"
                        md-label="الرقم الضماني"
                      >
                        {{ item.warrantyNumber }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 150px"
                        class="reportFont"
                        md-label="ملاحظات"
                      >
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>

                <div
                  class="md-layout mt-25"
                  style="direction: rtl; padding: 16px 30px"
                >
                  <div class="md-layout-item md-size-100">
                    <p class="reportFont">
                      1. الوعاء الضماني يشمل المرتب الأساسي + ع السكن + ع
                      العائلة
                    </p>
                  </div>

                  <div class="md-layout-item md-size-100">
                    <p class="reportFont">
                      2. حصة المضمون = الوعاء الضماني * 5.125% + حصة جهة العمل =
                      الوعاء الضماني * 10.500% + حصة الخزانة = الوعاء الضماني *
                      0.750%
                    </p>
                  </div>
                </div>
              </md-card>
            </div>
          </div>
        </div>

        <!-- تقرير صرف رواتب عن شهر -->
        <ViewReport5pdf
          :allData="allPaymentPerMonth"
          :month="convert_MonthToUi(monthDate)"
          :theMonth="convert_Month(monthDate)"
          :date="convertToUi(new Date())"
          :pathLogo="pathLogo"
          v-if="st == 5"
        />

        <!-- شهادة المرتب  -->

        <ViewSalaryCertificate
          :allData="socialSolidarities"
          :date="date"
          v-if="st == 17"
        />

        <!-- حافظة ارفاق صك -->
        <ViewReport14
          :month="convert_MonthToUi(monthDate)"
          :name="companyName"
          :desc="companyDesc"
          :date="convertToUi(new Date())"
          :allData="salariesChequeData"
          v-if="st == 14"
        />

        <!-- كشف الموقوفين -->

        <div v-if="st == 11">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-30">
              <h4 class="text-left" style="margin-left: 50px">
                التاريخ : {{ convert(date) }}
              </h4>
            </div>

            <div class="md-layout-item md-size-30 mt-25">
              <h3 class="text-center">كشف الموقوفين</h3>
              <h4 class="text-center">{{ convert_Month(monthDate) }} عن شهر</h4>
            </div>

            <div style="text-align: end" class="md-layout-item md-size-30">
              <h3 class="text-right">{{ name.fullName }}</h3>
              <h4 class="text-right">{{ name.shortName }}</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">كشف الموقوفين</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field>
                      <label> عدد الموظفين </label>
                      <md-input disabled v-model="id_all"></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="ر.م">{{
                        item.id
                      }}</md-table-cell>
                      <md-table-cell md-label="الرقم المالي">{{
                        item.financialNumber
                      }}</md-table-cell>

                      <md-table-cell
                        style="width: 400px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell style="width: 200px" md-label="المصرف">{{
                        item.bankBranchName
                      }}</md-table-cell>

                      <md-table-cell type="number" md-label="رقم الحساب">{{
                        item.accountNumber
                      }}</md-table-cell>

                      <md-table-cell md-label="بتاريخ">{{
                        convert(item.suspentionDate)
                      }}</md-table-cell>

                      <md-table-cell md-label="المجموعة"></md-table-cell>

                      <md-table-cell md-label="سبب الإيقاف">{{
                        item.suspentionNote
                      }}</md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>

                  <!-- <div style="
            padding: 9px 0px;
            background-color: #c3bebe;
            text-align: center;
          " class="table table-stats">
                            <div class="td-price">
                                <span style="font-weight: bold">
                                    عدد الموظفين =
                                    <small style="font-weight: bold; font-size: 14px">{{
                                            id_all
                                    }}</small>
                                </span>
                            </div>
                        </div> -->
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>

        <div style="padding: 30px">
          <ViewReport8
            :date="convertToUi(new Date())"
            :start="convertToUi(StartOn)"
            :finish="convertToUi(FinishOn)"
            :name="companyName"
            :desc="companyDesc"
            :totalSalary="totalSalary"
            :totalSolidarityTax="totalSolidarityTax"
            :allData="socialSolidarities"
            v-if="st == 8"
          />

          <ViewReport13
            :month="convert_Month(monthDate)"
            :date="convert(date)"
            :name="companyName"
            :desc="companyDesc"
            :allData="generalAnalytical"
            v-if="st == 13"
          />

          <ViewReport18
            :month="convert_Month(monthDate)"
            :date="convert(date)"
            :name="companyName"
            :desc="companyDesc"
            :allData="generalAnalytical"
            v-if="st == 18"
          />

          <ViewSalaryCard
            :allData="socialSolidarities"
            :tableData="tableData_card"
            :allowances="allowances"
            v-if="st == 16"
          />

          <GetEmployeesFinancialInfosTable
            v-if="st == 19"
            :data="employeesFinancialInfosData"
          />
        </div>

        <!--------------- print --------------->

        <md-card-content
          v-if="
            st == 2 ||
            st == 4 ||
            st == 5 ||
            st == 7 ||
            st == 8 ||
            st == 9 ||
            st == 11 ||
            st == 13 ||
            st == 14 ||
            st == 15 ||
            st == 16 ||
            st == 17
          "
        >
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            filename="Social Solidarity"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a2"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            :html-to-pdf-options="{
              margin: [10, 10, st == 8 ? '5' : '5', 10],
              filename: stName,
              jsPDF: {
                format: `a2`,
                orientation: st == 16 ? 'landscape' : 'portrait',
              },
              html2canvas: {
                scale: 1,
                useCORS: true,
                dpi: 300,
                letterRendering: true,
              },
            }"
            ref="html2Pdf"
            @beforeDownload="beforeDownload($event)"
            @progress="progressPdf"
            @startPagination="startPagination"
            @hasPaginated="hasPaginated"
            @hasDownloaded="hasDownloaded"
          >
            <section class="pdf-container d-flex" slot="pdf-content">
              <!-- PDF Content Here -->
              <div v-if="st == 2">
                <div style="margin-top: 200px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>
                <h3 class="text-center">{{ name.fullName }}</h3>
                <h3 class="text-center">{{ name.shortName }}</h3>
                <h3 class="text-center">كشف تجميعي للحوافظ</h3>
                <h4 class="text-center">
                  {{ convert_Month(monthDate) }} عن شهر
                </h4>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="report paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell class="reportFont" md-label="ر.م">{{
                        item.id
                      }}</md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="اسم المصرف"
                        >{{ item.bankBranchName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="العدد"
                        >{{ item.count }}
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="القيمة
                            (د.ل)"
                        >{{ item.value }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="رقم الصك"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>

                  <md-table
                    dir="rtl"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row">
                      <md-table-cell
                        class="reportFont"
                        style="width: 60px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>عدد الموظفين</p>
                          <p>= {{ tableData.totalCount }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>مجموع الحوافظ</p>
                          <p>= {{ tableData.totalValue }}</p>
                        </div>
                      </md-table-cell>

                      <!-- <md-table-cell class="reportFont" style="width: 200px" md-label="ملاحظة">
                                                عدد الموظفين = {{ tableData.totalCount }}
                                            </md-table-cell> -->
                      <!-- <md-table-cell class="reportFont" style="width: 250px" md-label="ملاحظة">
                                                مجموع الحوافظ = {{
                                                    tableData.totalValue
                                                }}
                                            </md-table-cell> -->
                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </div>

              <!-- بطاقة مرتب الموظف -->
              <salaryCard
                :allData="socialSolidarities"
                :tableData="tableData_card"
                :allowances="allowances"
                :pathLogo="pathLogo"
                v-if="st == 16"
              />

              <SalaryCertificate
                :allData="socialSolidarities"
                :date="date"
                :pathLogo="pathLogo"
                v-if="st == 17"
              />

              <!-- تقرير صرف رواتب عن شهر -->
              <Report5pdf
                :allData="allPaymentPerMonth"
                :month="convert_MonthToUi(monthDate)"
                :theMonth="convert_Month(monthDate)"
                :date="convertToUi(new Date())"
                :pathLogo="pathLogo"
                v-if="st == 5"
              />

              <!-- كشف حصر التضامن -->
              <Report8pdf
                :date="convertToUi(new Date())"
                :start="convertToUi(StartOn)"
                :finish="convertToUi(FinishOn)"
                :name="companyName"
                :desc="companyDesc"
                :totalSalary="totalSalary"
                :totalSolidarityTax="totalSolidarityTax"
                :allData="socialSolidarities"
                :pathLogo="pathLogo"
                v-if="st == 8"
              />

              <!-- الكشف التحليلى لشهر -->
              <Report13pdf
                :month="convert_Month(monthDate)"
                :date="convert(date)"
                :name="companyName"
                :desc="companyDesc"
                :allData="generalAnalytical"
                :pathLogo="pathLogo"
                v-if="st == 13"
              />

              <!-- حافظة ارفاق صك -->
              <!-- <Report14pdf :month="convert_MonthToUi(monthDate)" :name="companyName" :desc="companyDesc"
                                :date="convertToUi(new Date())" :allData="salariesChequeData" :pathLogo="pathLogo"
                                v-if="st == 14" /> -->

              <!-- الكشف التحليلى العام => Canceled -->
              <Report15pdf
                :date="convertToUi(new Date())"
                :name="companyName"
                :desc="companyDesc"
                :pathLogo="pathLogo"
                v-if="st == 15"
              />

              <div v-if="st == 4">
                <div style="margin-top: 200px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>
                <h3 class="text-center">{{ name.fullName }}</h3>
                <h3 class="text-center">{{ name.shortName }}</h3>
                <h3 class="text-center">كشف مرتبات عن شهر</h3>
                <h4 class="text-center">
                  {{ convert_Month(monthDate) }}
                </h4>

                <h4 class="text-left" style="margin-left: 50px; direction: ltr">
                  التاريخ : {{ convertToUi(new Date()) }}
                </h4>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        style="width: 100px"
                        class="reportFont"
                        md-label="ر.م"
                        >{{ item.id }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 140px"
                        md-label="رقم المالي"
                        >{{ item.financialNumber }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 300px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإجمالي
                            (د.ل)"
                        >{{ item.totalSalary }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الإستقطاعات
                            (د.ل)"
                        >{{ item.totalDiscounts }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="صافي المرتب
                            (د.ل)"
                        >{{ item.netSalary }}</md-table-cell
                      >

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>

                  <md-table
                    dir="rtl"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row">
                      <md-table-cell
                        class="reportFont"
                        style="width: 100px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 140px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 300px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي المرتب</p>
                          <p>= {{ tableData.totalSalaries }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي الخصميات</p>
                          <p>= {{ tableData.totalDiscountsValue }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي صافي المرتب</p>
                          <p>= {{ tableData.totalNetSalary }}</p>
                        </div>
                      </md-table-cell>
                      <!-- <md-table-cell class="reportFont" style="width: 250px" md-label="ملاحظة">
                                                اجمالي المرتب = {{
                                                    tableData.totalSalaries
                                                }}
                                            </md-table-cell>
                                            <md-table-cell class="reportFont" style="width: 250px" md-label="ملاحظة">
                                                اجمالي الخصميات = {{ tableData.totalDiscountsValue }}
                                            </md-table-cell>
                                            <md-table-cell class="reportFont" style="width: 250px" md-label="ملاحظة">
                                                اجمالي صافي المرتب = {{
                                                    tableData.totalNetSalary
                                                }}
                                            </md-table-cell> -->

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>

                <div class="md-layout mt-25 text-center">
                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">رئيس قسم الحسابات</p>
                  </div>

                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">المراجعة الداخلية</p>
                  </div>

                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">المراقب المالي</p>
                  </div>
                </div>
              </div>

              <div v-if="st == 7">
                <div style="margin-top: 300px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>

                <h3 class="text-center">{{ name.fullName }}</h3>
                <h3 class="text-center">{{ name.shortName }}</h3>
                <h3 class="text-center">تقرير الجهاد</h3>
                <div class="text-center" style="direction: ltr; display: flex">
                  <h4 style="padding-right: 30px" class="text-center">
                    {{ convert_Month(FinishOn) }} الى شهر
                  </h4>

                  <h4 class="text-center">
                    {{ convert_Month(StartOn) }} من شهر
                  </h4>
                </div>

                <h4 class="text-left" style="margin-left: 50px; direction: ltr">
                  التاريخ : {{ convertToUi(new Date()) }}
                </h4>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        style="width: 60px"
                        class="reportFont"
                        md-label="ر.م"
                        >{{ item.id }}</md-table-cell
                      >

                      <md-table-cell
                        type="number"
                        class="reportFont"
                        style="width: 150px"
                        md-label="الرقم المالي"
                        >{{ item.financialNumber }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="الإسم"
                        >{{ item.employeeName }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 200px"
                        class="reportFont"
                        md-label="الخاضع للضريبة
                            (د.ل)"
                        >{{ item.totalSalary }}</md-table-cell
                      >

                      <md-table-cell
                        style="width: 200px"
                        class="reportFont"
                        md-label="قيمة الجهاد
                            (د.ل)"
                        >{{ item.jihadTax }}
                      </md-table-cell>

                      <md-table-cell style="width: 5px"></md-table-cell>
                    </md-table-row>
                  </md-table>

                  <md-table
                    dir="rtl"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row">
                      <md-table-cell
                        class="reportFont"
                        style="width: 60px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 150px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي الخاضع للضريبة</p>
                          <p>= {{ tableData.totalSalaries }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="ملاحظة"
                      >
                        <div style="text-align: center">
                          <p>اجمالي قيمة الجهاد</p>
                          <p>= {{ tableData.totalJihadTax }}</p>
                        </div>
                      </md-table-cell>
                      <md-table-cell style="width: 5px"></md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>

                <div class="md-layout mt-25 text-center">
                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">رئيس قسم الحسابات</p>
                  </div>

                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">المراجعة الداخلية</p>
                  </div>

                  <div class="md-layout-item md-size-30">
                    <p style="font-weight: bold">المراقب المالي</p>
                  </div>
                </div>
              </div>

              <div v-if="st == 9">
                <div style="margin-top: 200px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>

                <div class="md-layout-item md-size-100">
                  <h4 class="text-center">
                    <span style="font-weight: bold">{{ name.fullName }}</span>
                  </h4>
                  <h4 class="text-center">{{ name.shortName }}</h4>
                </div>

                <div class="md-layout-item md-size-100 mt-25">
                  <h3 class="text-center">كشف حصر الاشتراكات الضمانية</h3>
                  <h4 class="text-center">
                    المستحقة لصالح الضمان الإجتماعي لدى وزارة المالية للمضمونين
                    لغرض المطابقة مع ماتم سداده للخصم المباشر
                  </h4>
                  <div
                    class="text-center"
                    style="direction: ltr; display: flex"
                  >
                    <h4 class="text-center">
                      {{ convert_Month(FinishOn) }} الى شهر
                    </h4>

                    <h4 style="padding-left: 15px" class="text-center">
                      {{ convert_Month(StartOn) }} من شهر
                    </h4>
                  </div>
                </div>

                <div class="md-layout-item md-size-100">
                  <h4 class="text-left" style="margin-left: 50px">
                    التاريخ : {{ convert(date) }}
                  </h4>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell
                        style="width: 100px"
                        class="reportFont"
                        md-label="ر.م"
                        >{{ item.id }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="الرتب الخاضع للضمان"
                        >{{ formatValues(item.totalSalry) }}</md-table-cell
                      >

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة المضمون 5.125%"
                      >
                        {{ formatValues(item.warrantyTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة جهة العمل  10.500%"
                      >
                        {{ formatValues(item.employerTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 250px"
                        class="reportFont"
                        md-label="حصة الخزانة  0.750%"
                      >
                        {{ formatValues(item.cabinetTax) }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 100px"
                        class="reportFont"
                        md-label="الرقم الضماني"
                      >
                        {{ item.warrantyNumber }}
                      </md-table-cell>

                      <md-table-cell
                        style="width: 150px"
                        class="reportFont"
                        md-label="ملاحظات"
                      >
                      </md-table-cell>
                    </md-table-row>
                  </md-table>

                  <md-table
                    dir="rtl"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row">
                      <md-table-cell
                        class="reportFont"
                        style="width: 100px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 350px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي</p>
                          <p>الراتب الخاضع للضمان</p>
                          <p>= {{ tableData.totalSalries }}</p>
                        </div>
                      </md-table-cell>
                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي</p>

                          <p>حصة المضمون</p>
                          <p>= {{ tableData.totalWarrantyTax }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي</p>

                          <p>حصة جهة العمل</p>
                          <p>= {{ tableData.totalEmployerTax }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="ملاحظة"
                      >
                        <div>
                          <p>اجمالي</p>

                          <p>حصة الخزانة</p>
                          <p>= {{ tableData.totalCabinetTax }}</p>
                        </div>
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 100px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 150px"
                        md-label="ملاحظة"
                      >
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>

                <div
                  class="md-layout mt-25"
                  style="direction: rtl; padding: 16px 30px"
                >
                  <div class="md-layout-item md-size-100">
                    <p class="reportFont">
                      1. الوعاء الضماني يشمل المرتب الأساسي + ع السكن + ع
                      العائلة
                    </p>
                  </div>

                  <div class="md-layout-item md-size-100">
                    <p class="reportFont">
                      2. حصة المضمون = الوعاء الضماني * 5.125% + حصة جهة العمل =
                      الوعاء الضماني * 10.500% + حصة الخزانة = الوعاء الضماني *
                      0.750%
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="st == 11">
                <div style="margin-top: 200px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>
                <h3 class="text-center">{{ name.fullName }}</h3>
                <h3 class="text-center">{{ name.shortName }}</h3>
                <h3 class="text-center">كشف الموقوفين</h3>
                <h4 class="text-center">
                  {{ convert_Month(monthDate) }} عن شهر
                </h4>

                <h4 class="text-left" style="margin-left: 50px; direction: ltr">
                  التاريخ : {{ convertToUi(new Date()) }}
                </h4>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="ر.م">{{
                        item.id
                      }}</md-table-cell>
                      <md-table-cell md-label="الرقم المالي">{{
                        item.financialNumber
                      }}</md-table-cell>

                      <md-table-cell
                        style="width: 400px"
                        md-label="اسم الموظف"
                        >{{ item.employeeName }}</md-table-cell
                      >

                      <md-table-cell style="width: 200px" md-label="المصرف">{{
                        item.bankBranchName
                      }}</md-table-cell>

                      <md-table-cell md-label="رقم الحساب">{{
                        item.accountNumber
                      }}</md-table-cell>

                      <md-table-cell md-label="بتاريخ">{{
                        convert(item.suspentionDate)
                      }}</md-table-cell>

                      <md-table-cell md-label="المجموعة"></md-table-cell>

                      <md-table-cell md-label="سبب الإيقاف">{{
                        item.suspentionNote
                      }}</md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>

                  <div
                    style="
                      padding: 9px 0px;
                      background-color: #c3bebe;
                      text-align: center;
                    "
                    class="table table-stats"
                  >
                    <div class="td-price">
                      <span style="font-weight: bold">
                        عدد الموظفين =
                        <small style="font-weight: bold; font-size: 14px">{{
                          id_all
                        }}</small>
                      </span>
                    </div>
                  </div>
                </md-card-content>
              </div>
            </section>
          </vue-html2pdf>

          <!-- should be disply block -->
          <div class="md-layout flex-content-left" style="display: none">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <!-- <md-table
              :value="staffReportData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover mt-25"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="اسم المصرف">{{
                  item.bankBranchName
                }}</md-table-cell>
  
                <md-table-cell md-label="العدد">{{
                  item.count
                }}</md-table-cell>
  
                <md-table-cell md-label="القيمة">{{
                  item.value
                }}</md-table-cell>
  
               
                <md-table-cell md-label>
                  <div class="md-just-icon md-info md-simple"></div>
                  <md-button
                    class="md-just-icon md-warning md-simple"
                    @click.native="handleEdit(item)"
                  >
                    <md-icon>dvr</md-icon>
                  </md-button>
                   <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="handleDelete(item)"
                  >
                    <md-icon>close</md-icon>
                  </md-button> 
                 </md-table-cell>
              </md-table-row>
            </md-table>  -->
          <!-- <div class="footer-table md-table">
              <table>
                <tfoot>
                  <tr>
                    <th
                      v-for="item in footerTable"
                      :key="item.name"
                      class="md-table-head"
                    >
                      <div class="md-table-head-container md-ripple md-disabled">
                        <div class="md-table-head-label">{{ item }}</div>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div> -->
        </md-card-content>

        <!-- <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions> -->
      </md-card>
    </div>
  </div>
</template>

<script>
import GetEmployeesFinancialInfosTable from "./../../../../components/GetEmployeesFinancialInfosTable.vue";
import Lodding from "../../../../Lodding.vue";
import Report5 from "../../../../components/Reports/Report-5.vue";
import Report5pdf from "../../../../components/Reports/Report-5-pdf.vue";
import ViewReport5pdf from "../../../../components/ViewReports/ViewReport-5-pdf.vue";

import Report8 from "../../../../components/Reports/Report-8.vue";
import Report8pdf from "../../../../components/Reports/Report-8-pdf.vue";
import SalaryReportByBank from "../../../../components/Reports/SalaryReportByBank.vue";
import OverTimeReport from "../../../../components/Reports/OverTimeReport.vue";

import ViewReport8 from "../../../../components/ViewReports/ViewReport8.vue";

import Report13 from "../../../../components/Reports/Report-13.vue";
import Report13pdf from "../../../../components/Reports/Report-13-pdf.vue";
import ViewReport13 from "../../../../components/ViewReports/ViewReport13.vue";
import ViewReport18 from "../../../../components/ViewReports/ViewReport18.vue";

import Report14 from "../../../../components/Reports/Report-14.vue";
import Report14pdf from "../../../../components/Reports/Report-14-pdf.vue";
import ViewReport14 from "../../../../components/ViewReports/ViewReport-14.vue";
import Report15 from "../../../../components/Reports/Report-15.vue";
import Report15pdf from "../../../../components/Reports/Report-15-pdf.vue";
// import Report16 from "../../../../components/Reports/Report-16.vue";
import salaryCard from "../../../../components/Reports/salary card.vue";
import SalaryCertificate from "../../../../components/Reports/SalaryCertificate.vue";
import ViewSalaryCertificate from "../../../../components/ViewReports/ViewSalaryCertificate.vue";
import Excel2 from "../../../../components/ExcelReports/Report-2.vue";
import Excel4 from "../../../../components/ExcelReports/Report-4.vue";
import Excel5 from "../../../../components/ExcelReports/Report-5.vue";
import Excel7 from "../../../../components/ExcelReports/Report-7.vue";
import Excel8 from "../../../../components/ExcelReports/Report-8.vue";
import Excel9 from "../../../../components/ExcelReports/Report-9.vue";
import Excel11 from "../../../../components/ExcelReports/Report-11.vue";
import Excel13 from "../../../../components/ExcelReports/Report-13.vue";
import Excel14 from "../../../../components/ExcelReports/Report-14.vue";

import ViewSalaryCard from "../../../../components/ViewReports/ViewSalaryCard.vue";

import {
  AtomSpinner,
  HollowDotsSpinner,
  LoopingRhombusesSpinner,
} from "epic-spinners";
import StepProgress from "vue-step-progress";
import VueHtml2pdf from "vue-html2pdf";
// import { AtomSpinner } from "epic-spinners";
// import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";

import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
import { param } from "jquery";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
    const styleValue = localStorage.getItem("privateCompanyMode");
    this.privateCompanyMode = styleValue === "true";
  },

  components: {
    GetEmployeesFinancialInfosTable,
    SalaryReportByBank,
    OverTimeReport,
    // Pagination,
    Lodding,
    ModelListSelect,
    VueHtml2pdf,
    // Report5,
    // Report8,
    // Report13,
    // Report14,
    SalaryCertificate,
    ViewSalaryCertificate,
    // Report15,
    // Report16,
    Report5pdf,
    ViewReport5pdf,
    Report8pdf,
    Report13pdf,
    // Report14pdf,
    ViewReport14,
    Report15pdf,
    salaryCard,
    AtomSpinner,
    StepProgress,
    Excel2,
    Excel4,
    Excel5,
    Excel7,
    Excel8,
    Excel9,
    Excel11,
    Excel13,
    // Excel14,
    ViewSalaryCard,
    ViewReport8,
    ViewReport13,
    ViewReport18,
    // AtomSpinner,
    // StepProgress,
  },

  computed: {
    isMultiCurrency() {
      return this.$store.state.global.profile.isMultiCurrency;
    },
    globalEmployeesData() {
      return this.$store.getters["global/employeesData"];
    },
    globalCompanyInfo() {
      return this.$store.getters["global/companyInfo"];
    },
    getCompanyName() {
      return this.companyName;
    },
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      detailedReport: false,
      employeesFinancialInfosData: [],
      CurrentReportList: [
        {
          id: "18",
          name: "تقرير المرتبات",
        },
        {
          id: "19",
          name: "تقرير البيانات المالية",
        },
        {
          id: "4",
          name: "كشف مرتبات عن الشهر",
        },

        {
          id: "11",
          name: "كشف الموقوفين",
        },

        {
          id: "17",
          name: "شهادة المرتب",
        },
        {
          id: "20",
          name: "تقرير المرتبات حسب مصرف",
        },
        {
          id: "21",
          name: "تقرير العمل الإضافي",
        },
      ],

      CurrentReportList_true: [
        {
          id: "18",
          name: "تقرير المرتبات",
        },

        {
          id: "16",
          name: "بطاقة المرتب للموظفين",
        },

        {
          id: "19",
          name: "تقرير البيانات المالية",
        },

        {
          id: "2",
          name: " كشف تجميعي للحوافظ",
        },
        {
          id: "4",
          name: "كشف مرتبات عن الشهر",
        },

        {
          id: "5",
          name: "تقرير صرف الرواتب عن شهر",
        },

        {
          id: "7",
          name: "كشف ضريبة الجهاد",
        },

        {
          id: "8",
          name: "كشف حصر التضامن",
        },

        {
          id: "9",
          name: "كشف حصر الاشتراكات الضمانية",
        },

        {
          id: "11",
          name: "كشف الموقوفين",
        },

        {
          id: "14",
          name: "حافظة ارفاق صك",
        },

        {
          id: "16",
          name: "بطاقة المرتب للموظفين",
        },

        {
          id: "17",
          name: "شهادة المرتب",
        },
        {
          id: "20",
          name: "تقرير المرتبات حسب مصرف",
        },
        {
          id: "21",
          name: "تقرير العمل الإضافي",
        },
      ],

      privateCompanyMode: false,
      EmployeesId: [],
      includeJobInfo: false,
      exc: false,
      lodding_bool: "",
      errorMessage: "",
      m: env.mTop(),
      pathLogo: "",
      st5Array: [
        "تقرير صرف الرواتب عن شهر",
        "شركة البرمجيات الدقيقة",
        "للحلول البرمجية وخدمات تقنية المعلومات",
      ],
      bankClassifications: [],
      bankClassificationId: null,
      totalSolidarityTax: "",
      totalSalary: "",
      tableData_card: [],
      allowances: [],
      EmployeeId_Report: "",
      Year_Report: "",
      // errorMessage: "",
      socialSolidarities: "",
      companyName: "",
      companyDesc: "",
      monthDate: null,
      htmlToPdfOptions: {
        margin: [10, 10, 51, 10],
        filename: `momen.pdf`,
        jsPDF: {
          format: "a2",
          orientation: "portrait",
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          dpi: 300,
          letterRendering: true,
        },
      },
      id_all: 0,
      st: 0,
      showPdf: true,
      stName: "",
      allBanks: [],
      deparmentClassifications: [],
      FilterDeparmentClassificationsIds: [],
      selectBank: null,
      allBankBranches: [],
      selectBankBranch: null,
      pdfLoadingActive: false,
      generalAnalytical: [],
      salariesChequeData: [], // حافظة ارفاق صك
      allPaymentPerMonth: "", // صرف رواتب عن شهر
      mySteps: ["بدء التحميل", "جارى التحميل", "تم التحميل"],
      currentStep: 0,
      staffReportData: [],
      name: [],

      isActive: false,
      id: localStorage.getItem("idTable"),

      one: true,
      tow: false,

      IsAll: false,
      IsAllEmployees: false,
      EmployeeId: "00000000-0000-0000-0000-000000000000",
      TypeId: "00000000-0000-0000-0000-000000000000",
      StartOn: null,
      FinishOn: null,
      Note: "",
      Type: "",
      employeeFullName: "",
      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",
      balance: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
      CurrentPage: "",
      Types: [],
      StartingBonus: "",
      StartingGrade: "",
      dateFrom: "",
      dateTo: "",
      date: "",
      theToken: localStorage.getItem("Nannotoken"),
      reportUrl: "https://nanosoft.live/hr-reports/api",
    };
  },

  methods: {
    formatValues(value) {
      if (!value) {
        return value;
      }
      return value.toLocaleString();
    },
    printReportFromApi(reportNumber) {
      console.warn("test");
      const token = atob(this.theToken);
      const baseUrl = env.HR();
      if (reportNumber == 2) {
        this.salariesPerBankBranch(token, baseUrl);
      }

      if (reportNumber == 4) {
        this.grossSalary(token, baseUrl);
      }

      if (reportNumber == 7) {
        this.jihadTax(token, baseUrl);
      }

      if (reportNumber == 8) {
        this.socialSolidarity(token, baseUrl);
      }

      if (reportNumber == 9) {
        this.INSA(token, baseUrl);
      }

      if (reportNumber == 11) {
        this.SuspendedEmployees(token, baseUrl);
      }
      if (reportNumber == 13) {
        this.GeneralAnalytical(token, baseUrl);
      }

      if (reportNumber == 18) {
        this.SalaryInfosFile(1);
      }

      if (reportNumber == 14) {
        this.SalariesChequePerBankBranch(token, baseUrl);
      }
    },

    // كشف تجميعي للحوافظ
    async salariesPerBankBranch(token, baseUrl) {
      this.lodding_bool = true;
      try {
        let schema = {
          MonthDate: this.convert(this.monthDate),
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        if (!this.FinishOn) {
          delete schema.to;
        }

        const urlApi = `${env.HR()}/api/SalariesReports/SalariesPerBankBranchPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "تقرير كشف تجميعي للحوافظ.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // كشف مرتبات عن الشهر
    async grossSalary(token, baseUrl) {
      this.lodding_bool = true;
      try {
        let schema = {
          MonthDate: this.convert(this.monthDate),
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        if (!this.FinishOn) {
          delete schema.to;
        }

        const urlApi = `${env.HR()}/api/SalariesReports/GrossSalaryPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "تقرير كشف المرتبات عن شهر.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // تقرير كشف ضريبة الجهاد
    async jihadTax(token, baseUrl) {
      this.lodding_bool = true;
      try {
        if (this.StartOn == null) {
          this.StartOn = null;
        } else {
          this.StartOn = this.convert(this.StartOn);
        }

        if (this.FinishOn == null) {
          this.FinishOn = null;
        } else {
          this.FinishOn = this.convert(this.FinishOn);
        }

        let schema = {
          From: this.StartOn,
          To: this.FinishOn == "-" ? null : this.FinishOn,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        if (!this.FinishOn) {
          delete schema.to;
        }

        const urlApi = `${env.HR()}/api/SalariesReports/JihadTaxPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "كشف ضريبة الجهاد.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // تقرير كشف حصر التضامن
    async socialSolidarity(token, baseUrl) {
      this.lodding_bool = true;
      try {
        if (this.StartOn == null) {
          this.StartOn = null;
        } else {
          this.StartOn = this.convert(this.StartOn);
        }

        if (this.FinishOn == null) {
          this.FinishOn = null;
        } else {
          this.FinishOn = this.convert(this.FinishOn);
        }

        let schema = {
          From: this.StartOn,
          To: this.FinishOn == "-" ? null : this.FinishOn,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const urlApi = `${env.HR()}/api/SalariesReports/SocialSolidarityPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = " كشف حصر التضامن.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // كشف حصر الإشتراكات الضمانية
    async INSA(token, baseUrl) {
      this.lodding_bool = true;
      try {
        if (this.StartOn == null) {
          this.StartOn = null;
        } else {
          this.StartOn = this.convert(this.StartOn);
        }

        if (this.FinishOn == null) {
          this.FinishOn = null;
        } else {
          this.FinishOn = this.convert(this.FinishOn);
        }
        let schema = {
          From: this.StartOn,
          To: this.FinishOn == "-" ? null : this.FinishOn,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const urlApi = `${env.HR()}/api/SalariesReports/INSAPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "كشف حصر الاشتراكات الضمانية.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // كشف الموقوفين
    async SuspendedEmployees(token, baseUrl) {
      this.lodding_bool = true;
      try {
        let schema = {
          MonthDate: this.convert(this.monthDate),
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const urlApi = `${env.HR()}/api/SalariesReports/SuspendedEmployeespdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = " كشف الموقوفين.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // كشف التحليلي لشهر
    async GeneralAnalytical(token, baseUrl) {
      this.lodding_bool = true;
      try {
        let schema = {
          MonthDate: this.convert(this.monthDate),
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const urlApi = `${env.HR()}/api/SalariesReports/GeneralAnalyticalPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = " كشف التحليلي لشهر.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    async SalaryInfosFile(reportType) {
      this.lodding_bool = true;
      try {
        if (!this.date) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال التاريخ "
          );
        }

        const types = {
          1: "pdf",
          2: "xlsx",
        };

        let schema = {
          reportType: reportType == 1 ? "pdf" : "excel",
          Date: this.convert(this.date),
          EmployeesId: this.EmployeesId.map((id) => id.key),
          includeJobInfo: this.includeJobInfo,
          BankId: null,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const response = await this.$axios.patch(
          "/api/SalariesReports/SalaryInfosFile",
          schema,
          {
            responseType: "blob", // Important to handle binary data
          }
        );

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], {
          type: "application/" + types[reportType],
        });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "تقرير المرتبات." + types[reportType];

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    // حافظة ارفاق صك
    async SalariesChequePerBankBranch(token, baseUrl) {
      this.lodding_bool = true;
      try {
        let schema = {
          MonthDate: this.convert(this.monthDate),
          BankId: this.selectBank,
          BankBranchId: this.selectBankBranch,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        const urlApi = `${env.HR()}/api/SalariesReports/SalariesChequePerBankBranchPdf`;
        const response = await axios.patch(urlApi, schema, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob", // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = "حافظة ارفاق صك.pdf";

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },

    downloadFileBlob(blob, name = "file") {
      const href = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement("a"), {
        href,
        style: "display:none",
        download: `${name}.pdf`,
      });
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(href);
      a.remove();
    },

    startDownload() {},
    finishDownload() {},

    clear_selectBank() {
      this.selectBank = "";
    },

    clear_selectBankBranch() {
      this.selectBankBranch = "";
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    clearfield(field) {
      this[field] = "";
    },

    async Search() {
      try {
        this.staffReportData = [];

        if (this.st == "19") {
          this.getEmployeesFinancialInfos();
        }

        if (this.st == 2) {
          if (!this.monthDate) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال شهر المرتب "
            );
          }
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            let schema = {
              MonthDate: this.convert(this.monthDate),
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };
            let result = await axios.patch(
              `${env.HR()}/api/SalariesReports/SalariesPerBankBranch`,
              schema,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            for (let i = 0; i < result.data.data.items.length; i++) {
              let schema = {
                id: i + 1,
                bankBranchName: result.data.data.items[i].bankBranchName,
                count: result.data.data.items[i].count,
                value: result.data.data.items[i].value,
              };
              this.staffReportData.push(schema);
            }

            this.tableData = result.data.data;

            // this.staffReportData = result.data.data.items;
            this.name = result.data.data;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        } else if (this.st == 4) {
          if (!this.monthDate) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال شهر المرتب "
            );
          }
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let schema = {
              MonthDate: this.convert(this.monthDate),
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };
            let result = await axios.patch(
              `${env.HR()}/api/SalariesReports/GrossSalary`,
              schema,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            for (let i = 0; i < result.data.data.items.length; i++) {
              let schema = {
                id: i + 1,
                ...result.data.data.items[i],
                // financialNumber: result.data.data.items[i].financialNumber,
                // employeeName: result.data.data.items[i].employeeName,
                // totalSalary: result.data.data.items[i].totalSalary,
                // totalDiscounts: result.data.data.items[i].totalDiscounts,
                // netSalary: result.data.data.items[i].netSalary,
              };
              this.staffReportData.push(schema);
            }

            this.tableData = result.data.data;
            this.name = result.data.data;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        } else if (this.st == 7) {
          if (!this.StartOn) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال من تاريخ الشهر"
            );
          }

          // if (!this.FinishOn) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء ادخال الى  تاريخ الشهر"
          //   );
          // }

          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            if (this.StartOn == null) {
              this.StartOn = "";
            } else {
              this.StartOn = this.convert(this.StartOn);
            }

            if (this.FinishOn == null) {
              this.FinishOn = "";
            } else {
              this.FinishOn = this.convert(this.FinishOn);
            }

            let schema = {
              From: this.StartOn,
              To: this.FinishOn,
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };

            if (!this.FinishOn) {
              delete schema.To;
            }

            let result = await axios.patch(
              `${env.HR()}/api/SalariesReports/JihadTax `,
              schema,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            for (let i = 0; i < result.data.data.items.length; i++) {
              let schema = {
                id: i + 1,
                financialNumber: result.data.data.items[i].financialNumber,
                employeeName: result.data.data.items[i].employeeName,
                totalSalary: result.data.data.items[i].totalSalary,
                jihadTax: result.data.data.items[i].jihadTax,
              };
              this.staffReportData.push(schema);
            }

            this.tableData = result.data.data;
            this.name = result.data.data;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        } else if (this.st == 9) {
          if (!this.StartOn) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال من تاريخ الشهر"
            );
          }

          // if (!this.FinishOn) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء ادخال الى  تاريخ الشهر"
          //   );
          // }

          if (this.StartOn == null) {
            this.StartOn = "";
          } else {
            this.StartOn = this.convert(this.StartOn);
          }

          if (this.FinishOn == null) {
            this.FinishOn = "";
          } else {
            this.FinishOn = this.convert(this.FinishOn);
          }
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let schema = {
              From: this.StartOn,
              To: this.FinishOn,
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };

            if (!this.FinishOn) {
              delete schema.To;
            }

            let result = await axios.patch(
              `${env.HR()}/api/SalariesReports/INSA `,
              schema,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            for (let i = 0; i < result.data.data.items.length; i++) {
              let schema = {
                id: i + 1,
                employeeName: result.data.data.items[i].employeeName,
                netSalary: result.data.data.items[i].netSalary,
                warrantyTax: result.data.data.items[i].warrantyTax,
                employerTax: result.data.data.items[i].employerTax,
                cabinetTax: result.data.data.items[i].cabinetTax,
                warrantyNumber: result.data.data.items[i].warrantyNumber,
                totalSalry: result.data.data.items[i].totalSalry,
              };
              this.staffReportData.push(schema);
              this.tableData = result.data.data;
            }

            // this.staffReportData = result.data.data.items;
            this.name = result.data.data;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        } else if (this.st == 8) {
          if (!this.StartOn) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال من تاريخ الشهر"
            );
          }

          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let schema = {
            From: moment(this.StartOn).format("YYYY-MM-DD"),
            To: moment(this.FinishOn).format("YYYY-MM-DD"),
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds,
            BankClassificationId: this.bankClassificationId,
          };

          if (!this.FinishOn) {
            delete schema.To;
          }

          let result = await axios.patch(
            `${env.HR()}/api/SalariesReports/SocialSolidarity`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
          this.socialSolidarities = result.data.data.socialSolidarities;
          this.totalSalary = result.data.data.totalSalary;
          this.totalSolidarityTax = result.data.data.totalSolidarityTax;

          // this.socialSolidarities.splice(2, 0, {
          //   key: "header",
          //   one: "ر.م",
          //   two: "البيان",
          //   three: "الدخل الإجمالى",
          //   four: "حصة التأمين 1 %",
          //   five: "ملاحظات",
          //   sex: "درهم",
          //   seven: "دينار",
          // });
        } else if (this.st == 11) {
          if (!this.monthDate) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال شهر المرتب "
            );
          }
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            let schema = {
              MonthDate: this.convert(this.monthDate),
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };

            let result = await axios.patch(
              `${env.HR()}/api/SalariesReports/SuspendedEmployees`,
              schema,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            for (let i = 0; i < result.data.data.items.length; i++) {
              let schema = {
                id: i + 1,
                financialNumber: result.data.data.items[i].financialNumber,
                employeeName: result.data.data.items[i].employeeName,
                bankBranchName: result.data.data.items[i].bankBranchName,
                accountNumber: result.data.data.items[i].accountNumber,
                suspentionDate: result.data.data.items[i].suspentionDate,
                // suspentionDate: result.data.data.items[i].suspentionDate,
                suspentionNote: result.data.data.items[i].suspentionNote,
              };
              this.staffReportData.push(schema);
              this.id_all = this.staffReportData.length;
            }

            // this.staffReportData = result.data.data.items;
            this.name = result.data.data;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        } else if (this.st == 13) {
          // الكشف التحليلى لشهر
          this.getGeneralAnalytical();
        } else if (this.st == 18) {
          this.SalaryInfosReport();
        } else if (this.st == 14) {
          // حافظة ارفاق صك

          this.salariesCheque();
        } else if (this.st == 5) {
          try {
            if (!this.monthDate) {
              return this.notifyVue(
                "top",
                "center",
                "danger",
                "عفواً، الرجاء ادخال شهر المرتب "
              );
            }

            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            let schema = {
              MonthDate: this.convert(this.monthDate),
              BankId: this.selectBank,
              BankBranchId: this.selectBankBranch,
              FilterDeparmentClassificationsIds:
                this.FilterDeparmentClassificationsIds == ""
                  ? null
                  : this.FilterDeparmentClassificationsIds,
              BankClassificationId: this.bankClassificationId,
            };

            let res = await axios.patch(
              `${env.HR()}/api/SalariesReports/SalariesPaymentPerMonth`,
              schema,

              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.allPaymentPerMonth = "";
            this.allPaymentPerMonth = res.data.data.items;
          } catch (error) {
            this.allPaymentPerMonth = "";
            this.message(error);
          }
        }
        // بطاقة المرتب للموظفين
        else if (this.st == 16) {
          try {
            if (!this.EmployeeId_Report) {
              return this.notifyVue(
                "top",
                "center",
                "danger",
                "عفواً، الرجاء ادخال الموظف "
              );
            }
            if (!this.Year_Report) {
              return this.notifyVue(
                "top",
                "center",
                "danger",
                "عفواً، الرجاء ادخال السنة "
              );
            }

            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            // let schema = {
            //     EmployeeId: this.EmployeeId_Report,
            //     Specialization: this.Specialization,
            //     Year: this.Year,
            //     Place: this.Place
            // };
            let result = await axios.get(
              `${env.HR()}/api/SalariesReports/EmployeeSalary?EmployeeId=${
                this.EmployeeId_Report
              }&Year=${this.Year_Report}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            this.socialSolidarities = result.data.data;
            this.tableData_card = result.data.data.items;
            if (result.data.data.items != "") {
              this.allowances = result.data.data.items[0].allowances;
            }

            // this.fullName = result.data.data.fullName;
            // this.shortName = result.data.data.shortName;
          } catch (error) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "الرجاء اعادة تسجيل الدخول"
            );
          }
        } else if (this.st == 17) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);

            if (this.date == null) {
              this.date = "";
            } else {
              this.date = this.convert(this.date);
            }
            let result = await axios.get(
              `${env.HR()}/api/SalariesReports/GetSalaryReport?EmployeeId=${
                this.EmployeeId_Report
              }&Date=${this.date}&detailedReport=${this.detailedReport}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );

            this.socialSolidarities = JSON.parse(
              JSON.stringify({
                detailedReport: this.detailedReport,
                ...result.data.data,
              })
            );
          } catch (error) {
            this.message(error);
          }
        }
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
      // this.$refs.html2Pdf.generatePdf();
    },

    async progressPdf(event) {
      console.warn("progressPdf :::: ", event);
      event == 70 ? setTimeout(() => (this.currentStep = 1), 3000) : "";
      event == 100 ? (this.currentStep = 2) : "";
      event == 100
        ? setTimeout(() => (this.pdfLoadingActive = false), 600)
        : "";
      event == 100 ? setTimeout(() => (this.currentStep = 0), 650) : "";
    },

    async startPagination() {
      // console.warn("startPagination ::::");
      // this.pdfLoadingActive = true;
      // this.currentStep = 1;
    },

    async hasPaginated() {
      // console.warn("hasPaginated ::::");
      // this.currentStep = 2;
    },

    async generateReport_ex() {
      this.lodding_bool = true;

      if (this.st == "5") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let BankIdN;
        let BankBranchIdN;

        if (this.selectBank == null) {
          BankIdN = "";
        } else {
          BankIdN = this.selectBank;
        }

        if (this.selectBankBranch == null) {
          BankBranchIdN = "";
        } else {
          BankBranchIdN = this.selectBankBranch;
        }

        await fetch(
          `https://nanosoft.live/hr-reports/api/SalariesReports/GetSalariesPaymentPerMonthReport?reportTypes=1&BaseUrl=${env.HR()}&token=${token}&MonthDate=${this.convert(
            this.monthDate
          )}&BankId=${BankIdN}&BankBranchId=${BankBranchIdN}&FilterDeparmentClassificationsIds=${
            this.FilterDeparmentClassificationsIds
          }&BankClassificationId=${this.bankClassificationId}
          `
        )
          .then((response) => {
            this.lodding_bool = false;
            return response.blob();
          })
          .then((blob) => {
            downloadFile(blob);
          });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "تقرير صرف الرواتب عن شهر.xls",
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } else if (this.st == "14") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let BankId;
        let BankBranchId;

        if (this.selectBank == null) {
          BankId = "";
        } else {
          BankId = this.selectBank;
        }

        if (this.selectBankBranch == null) {
          BankBranchId = "";
        } else {
          BankBranchId = this.selectBankBranch;
        }

        await fetch(
          `https://nanosoft.live/hr-reports/api/SalariesReports/GetSalariesChequePerBankBranchReport?reportTypes=1&BaseUrl=${env.HR()}&token=${token}&MonthDate=${this.convert(
            this.monthDate
          )}&BankId=${BankId}&BankBranchId=${BankBranchId}&FilterDeparmentClassificationsIds=${
            this.FilterDeparmentClassificationsIds
          }&BankClassificationId=${this.bankClassificationId}
          `
        )
          .then((response) => {
            this.lodding_bool = false;
            return response.blob();
          })
          .then((blob) => {
            downloadFile(blob);
          });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "حافظة ارفاق صك.xls",
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      }
    },

    printExcel18() {
      try {
      } catch (error) {}
    },

    async getEmployeesFinancialInfos() {
      try {
        const params = {
          employeeId: this.EmployeeId_Report,
        };

        const { data } = await this.$axios(
          "/api/SalariesReports/GetEmployeesFinancialInfos",
          {
            params,
          }
        );

        this.employeesFinancialInfosData = data.data;
      } catch (error) {}
    },

    async printEmployeesFinancialInfosPDF() {
      try {
        const params = {
          employeeId: this.EmployeeId_Report,
        };

        const { data } = await this.$axios(
          "/api/SalariesReports/GetEmployeesFinancialInfosPDF",
          {
            params,
            responseType: "blob",
          }
        );

        const blob = new Blob([data], { type: "application/pdf" });

        downloadFile(blob);

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "تقرير البيانات المالية.pdf",
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } catch (error) {
        console.warn("error", error);
      }
    },

    async generateReport() {
      console.warn("object", this.st);

      if (!this.st) {
        return;
      }

      if (this.st == 19) {
        this.printEmployeesFinancialInfosPDF();
        return;
      }

      const theToken = atob(this.theToken);
      const baseUrl = env.HR();
      this.lodding_bool = true;

      if (this.st == "5") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let schema = {
            MonthDate: this.convert(this.monthDate),
            BankId: this.selectBank,
            BankBranchId: this.selectBankBranch,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds,
            BankClassificationId: this.bankClassificationId,
          };

          let result = await axios.patch(
            `${env.HR()}/api/SalariesReports/SalariesPaymentPerMonthPdf`,
            schema,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob",
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير صرف رواتب عن شهر.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
        }
      } else if (this.st == "14") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let BankIdN;
        let BankBranchIdN;

        if (this.selectBank == null) {
          BankIdN = "";
        } else {
          BankIdN = this.selectBank;
        }

        if (this.selectBankBranch == null) {
          BankBranchIdN = "";
        } else {
          BankBranchIdN = this.selectBankBranch;
        }

        const params = new URLSearchParams({
          reportTypes: 0,
          BaseUrl: env.HR(),
          token,
          MonthDate: this.convert(this.monthDate),
          BankId: BankIdN,
          BankBranchId: BankBranchIdN,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        });

        const response = await fetch(
          `https://nanosoft.live/hr-reports/api/SalariesReports/GetSalariesChequePerBankBranchReport?${params}`
        );
        this.lodding_bool = false;
        const blob = await response.blob();
        downloadFile(blob);

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "حافظة ارفاق صك.pdf",
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } else if (this.st == "16") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/SalariesReports/EmployeeSalaryPdf?EmployeeId=${
              this.EmployeeId_Report
            }&Year=${this.Year_Report}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob",
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير بطاقة المرتب للموظفين.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
        }
      } else if (this.st == "17") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          const params = {
            employeeId: this.EmployeeId_Report,
            Date: this.convert(this.date),
            detailedReport: this.detailedReport,
          };

          let result = await axios.get(
            `${env.HR()}/api/SalariesReports/GetSalaryReportPdf`,
            {
              headers: { Authorization: "Bearer " + token },
              params,
              responseType: "blob",
            }
          );

          const employee = this.employees.find(
            (emp) => emp.key === params.employeeId
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = `تقرير شهادة المرتب - ${employee?.value}.pdf`;

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "لا يوجد مرتب لهذا الموظف في هذا الشهر"
          );
        }
      }
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .set({ pagebreak: { avoid: "tr" } })
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          pdf.setFont("Amiri-Regular");
          // pdf.setR2L(true);
          pdf.setLanguage("ar-KW");
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(30);
            pdf.setTextColor(150);
            // pdf.text(
            //   this.companyName,
            //   pdf.internal.pageSize.getWidth() * 0.77,
            //   40,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   this.companyDesc,
            //   pdf.internal.pageSize.getWidth() * 0.63,
            //   55,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.1,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.5,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.9,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
          }
        })
        .save()
        .then(() => {
          this.lodding_bool = false;
          // this.pdfLoadingActive = false;
          // this.currentStep = 0;
        });
    },

    async hasDownloaded() {
      // console.warn("hasDownloaded ::::");
    },

    clear_bankClassificationId() {
      this.bankClassificationId = "";
    },

    convert(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    convert_Month(event) {
      try {
        if (!event) {
          return "     ....-...   ";
        }

        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },

    convert_MonthToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getMonth() + 1 + "-" + d.getFullYear();
      } catch (error) {}
    },

    // message(error) {
    //   if (error.response.data.message != undefined) {
    //     this.errorMessage = error.response.data.message;
    //   } else {
    //     this.errorMessage =
    //       error.response.data.errors[
    //         Object.keys(error.response.data.errors)[0]
    //       ][0];
    //   }

    //   return this.notifyVue("top", "center", "danger", this.errorMessage);
    // },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async getCompanyInfo() {
      this.companyName = this.globalCompanyInfo.fullName;
      this.companyDesc = this.globalCompanyInfo.shortName;
    },

    async getBankInfo() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(`${env.HR()}/api/SalariesReports`, {
        headers: { Authorization: "Bearer " + token },
      });

      this.allBanks = res.data.data.banks;
      this.deparmentClassifications = res.data.data.deparmentClassifications;
      this.bankClassifications = res.data.data.bankClassifications;
    },

    async getBankBranches(key) {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(`${env.HR()}/api/bank-branches/load/${key}`, {
        headers: { Authorization: "Bearer " + token },
      });

      this.allBankBranches = res.data.data;
    },

    // الكشف التحليلى لشهر
    async getGeneralAnalytical() {
      if (!this.monthDate) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }
      let schema = {
        Date: this.convert(this.monthDate),
        FilterDeparmentClassificationsIds:
          this.FilterDeparmentClassificationsIds == ""
            ? null
            : this.FilterDeparmentClassificationsIds,
        BankClassificationId: this.bankClassificationId,
      };
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.patch(
        `${env.HR()}/api/SalariesReports/GeneralAnalytical`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      this.generalAnalytical = res.data.data;
    },

    // تقرير المرتبات
    async SalaryInfosReport() {
      if (!this.date) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال التاريخ "
        );
      }

      let schema = {
        Date: this.convert(this.date),
        EmployeesId: this.EmployeesId.map((id) => id.key),
        includeJobInfo: this.includeJobInfo,
        BankId: null,
        FilterDeparmentClassificationsIds:
          this.FilterDeparmentClassificationsIds == ""
            ? null
            : this.FilterDeparmentClassificationsIds,
        BankClassificationId: this.bankClassificationId,
      };
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.patch(
        `${env.HR()}/api/SalariesReports/SalaryInfosReport`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      console.warn("res.data.data", res.data.data);

      this.generalAnalytical = res.data.data;
    },

    // حافظة ارفاق صك
    async salariesCheque() {
      try {
        if (!this.monthDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال شهر المرتب "
          );
        }

        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let schema = {
          MonthDate: this.convert(this.monthDate),
          BankId: this.selectBank,
          BankBranchId: this.selectBankBranch,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds,
          BankClassificationId: this.bankClassificationId,
        };

        let res = await axios.patch(
          `${env.HR()}/api/SalariesReports/SalariesChequePerBankBranch`,
          schema,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.salariesChequeData = "";
        this.salariesChequeData = res.data.data;
      } catch (error) {
        this.salariesChequeData = "";
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let resultLogo = await axios.get(
          `${env.HR()}/api/company-info/GetLogoPath`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.pathLogo = resultLogo.data.data.path;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    setFetchedGlobalData() {
      this.employees = this.globalEmployeesData.employees;
    },

    gobBack() {
      this.$router.push("/pages/evaluation");
    },

    clear() {
      (this.IsAllEmployees = false),
        (this.EmployeeId = ""),
        (this.TypeId = ""),
        (this.StartOn = null),
        (this.FinishOn = null),
        (this.Note = ""),
        (this.btn = "new");
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      (this.IsAllEmployees = item.isAllEmployees),
        (this.EmployeeId = item.employeeId),
        (this.TypeId = item.typeId),
        (this.StartOn = new Date(item.startOn)),
        (this.FinishOn = new Date(item.finishOn)),
        (this.Note = item.note),
        (this.btn = "Edit");
      this.idTable = item.id;
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/hr/Vacations/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            // this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  watch: {
    globalEmployeesData(newValue) {
      this.setFetchedGlobalData();
    },
    globalCompanyInfo(newValue) {
      this.getCompanyInfo();
    },
    selectBankBranch() {
      if (this.selectBankBranch) {
        this.exc = true;
      } else {
        this.exc = false;
      }
    },
    selectBank(newValue) {
      if (this.selectBank != "") {
        this.getBankBranches(newValue);
      } else {
        this.selectBankBranch = "";
      }
    },
    st(newValue) {
      this.staffReportData = [];
      this.tableData = [];
      switch (+newValue) {
        case 1:
          this.stName = "كشف المرتبات";

          break;
        case 2:
          this.stName = "كشف تجميعي للحوافظ";

          break;
        case 3:
          this.stName = "الحافظة المصرفية";

          break;
        case 4:
          this.stName = "كشف مرتبات عن الشهر";

          break;
        case 5:
          this.stName = "تقرير صرف الرواتب عن شهر";

          break;
        case 6:
          this.stName = "بطاقة المرتب الشهرية";

          break;
        case 7:
          this.stName = "كشف ضريبة الجهاد";

          break;
        case 8:
          this.stName = "كشف حصر التضامن";

          break;
        case 9:
          this.stName = "كشف حصر الإشتراكات الضمانية";

          break;
        case 10:
          this.stName = "كشف خصم الغياب";

          break;
        case 11:
          this.stName = "كشف الموقوفين";

          break;
        case 12:
          this.stName = "تقرير علاوات الموظف";

          break;
        case 13:
          this.stName = "الكشف التحليلى لشهر";

          break;
        // case 14:
        //     this.stName = "حافظة ارفاق صك";

        //     break;
        case 15:
          this.stName = "الكشف التحليلى العام";

          break;
        case 16:
          this.stName = "بطاقة المرتب للموظفين";

          break;

        case 17:
          this.stName = "شهادة المرتب";

          break;

        default:
          break;
      }
    },
  },

  // watch: {

  //   //  IsAllEmployees() {
  //   //   try {
  //   //       if(this.IsAllEmployees == true){
  //   //       this.IsAll = true;
  //   //       }
  //   //       else {
  //   //       this.IsAll = false;
  //   //       }

  //   //   } catch (error) {

  //   //     return this.notifyVue(
  //   //       "top",
  //   //       "center",
  //   //       "danger",
  //   //       "الرجاء اعادة تسجيل الدخول"
  //   //     );
  //   //   }
  //   // },
  // },

  async mounted() {
    if (this.globalEmployeesData) {
      await this.setFetchedGlobalData();
    }
    if (this.globalCompanyInfo) {
      await this.getCompanyInfo();
    }
    this.getBankInfo();
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>

<style lang="scss">
.md-table-head .md-table-head-label {
  padding-right: 0 !important;
}

.pdf-container header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.sub-head-time {
  margin-right: 20px;
  display: inline-block;
}

.overlay-pdf {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.head-loading-pdf {
  color: #4caf50;
  font-weight: bold;
}

.step-progress__wrapper-after {
  transform-origin: right center !important;
}

.reportFont {
  font-size: 17px;
  // font-weight: bold;
}

.rtl .md-table-head .md-table-head-label {
  font-size: 17px;
  font-weight: bold;
}

// .md-checkbox.md-checked .md-checkbox-container:after {
//     border-color: #9c27b0 !important;
//     top: 1px;
//     left: -214px !important;
// }
</style>
